export default "__VITE_ASSET__C0bgs4Pb__"